import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { useLocation, useParams, Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import constant from "../utils/constants";
import { compact, isEmpty, startCase } from "lodash";
import AuthContext from "../context/AuthContext";
import helpers from "../utils/helpers";
import moment from "moment";
import { CiSquareMinus, CiSquarePlus } from "react-icons/ci";
import Hierarchy from "./Users/Hierarchy";
import Pagination from "../components/Pagination";
import { FaRegPlusSquare, FaRegMinusSquare } from "react-icons/fa";
// import HierarchyNew from "./Users/HierarchyNew";
import DatePicker from "react-datepicker";

const AprofitDownline = () => {
  const parmas = useParams();
  const location = useLocation();
  const [id, setId] = useState("");
  const user_params = compact(location.pathname.split("/"));
  let { user, setAccountError } = useContext(AuthContext);
  let check = user_params[0];
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  const [getProperty, setProperty] = useState("none");
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [detailsData, setDetailsData] = useState([]);

  const [filter, setFilter] = useState({
    page: 1,
    page_size: 10,
    fromPeriod: previousDate,
    toPeriod: currentDate,
    filterByDay: "",
    created_by: parmas.id ? parmas.id : user?._id,
    userType: parmas.user_type ? parmas.user_type : user?.userType,
  });

  const handlePageClick = (event) => {
    setFilter((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
  };

  const showDetail = async (event, id, userType) => {
    try {
      const { status, data: response_users } = await apiGet(
        apiPath.reportMarket +
          "?fromPeriod=" +
          filter.fromPeriod +
          "&toPeriod=" +
          filter.toPeriod +
          "&user_id=" +
          id +
          "&userType=" +
          userType
      );
      if (status === 200) {
        if (response_users.success) {
          const detailDiv = document.getElementById(id);
          let table =
            '<td colSpan="12" class="abc new-table"><table width="100%" class="sub-table">';
          response_users.results?.data.forEach((item, index) => {
           
            var string =
              item?.eventType == "1"
                ? "SOCCER"
                : item?.eventType == "2"
                ? "TENNIS"
                : item?.eventType == "4"
                ? "CRICKET"
                : item?.eventType == "7"
                ? "HORSE RACING"
                : "CASINO" || null;

                var betFaireType= 
                item?.betFaireType == "bookmaker" ? "-Bookmaker"
                : item?.betFaireType == "fancy"
                ? "-FANCY_BET"
                : item?.eventType !="-1" && item?.betFaireType == "betfair"
                ? ""
                : item?.betFaireType == "sportBook" || item?.betFaireType == "premium_fancy"
                ? "-PREMIUM_BET"
                : "";

         if(item?.realCutAmount!=0) {
            table = table + `<tr>`;
            table = table + `<td width="5%"></td>`;

            table =
              table +
              `<td width="24%" style=color:#2789ce>${string + betFaireType}</td>`;
            table =
              table +
              `<td width="5%">${helpers.currencyFormat(
                item?.stake ? item?.stake.toFixed(2) : 0
              )}</td>`;
            table =
              table +
              `<td width="10%">${
                Math.sign(item?.realCutAmount) == -1
                  ? "<span class='text-danger'>" +
                    "(" +
                    helpers.currencyFormat(Math.abs(Number(item?.realCutAmount || 0).toFixed(2))) +
                    ")" +
                    "</span>"
                  : "<span class=''>" +
                    helpers.currencyFormat(Math.abs(Number(item?.realCutAmount || 0).toFixed(2)))
              }</span></td>`;

            table =
              table +
              `<td width="10%">${
                Math.sign(item?.realCutAmount) === -1
                  ? "<span class='text-danger'>" +
                    "(" +
                    helpers.currencyFormat(Math.abs(Number(item?.realCutAmount || 0).toFixed(2))) +
                    ")" +
                    "</span>"
                  : "<span class=''>" +
                    helpers.currencyFormat(Math.abs(Number(item?.realCutAmount || 0).toFixed(2)))
              }</span></td>`;
            table =
              table +
              `<td width="10%">${helpers.currencyFormat(Math.abs(Number(item?.stake?.commission || 0).toFixed(2)))}</td>`;
            table = table + `<td width="10%">0.00</td>`;
            table = table + `<td width="10%">0.00</td>`;
            table = table + `<td width="10%">0.00</td>`;
            table =
              table +
              `<td width="10%">${
                Math.sign(item?.realCutAmount) !== -1
                  ? "<span class='text-danger'>" +
                    "(" +
                    helpers.currencyFormat(Math.abs(Number(item?.realCutAmount || 0).toFixed(2))) +
                    ")" +
                    "</span>"
                  : "<span class=''>" +
                    helpers.currencyFormat(Math.abs(Number(item?.realCutAmount || 0).toFixed(2)))
              }</span></td>`;

            table += `</tr>`;
            }
          });
          table += "</table></td >";

          if (detailDiv.style.display === "none") {
            detailDiv.style.setProperty("display", "contents");
            // event.target.className = "fas fa-minus-square pe-2";
            detailDiv.innerHTML = table;
          } else {
            detailDiv.style.setProperty("display", "none");
            // event.target.className = "fas fa-plus-square pe-2";
            detailDiv.innerHTML = "";
          }
        }
      }
    } catch (err) {
      // console.log("err",err)
      toast.error(err.response.data.message);
    }
  };
  useEffect(() => {
    setFilter((prevState) => {
      return {
        ...prevState,
        created_by: parmas?.id,
        userType: parmas?.user_type,
      };
    });
  }, [parmas?.id]);
  const [obj, setObj] = useState({});
  const [data, setData] = useState([]);
  const [sumData, setSumData] = useState({});

  const getData = async (type = "search") => {
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }
    let path;
    if (check == "AprofitDownline") {
      path = apiPath.reportDownline;
    } else {
      path = apiPath.reportMarket;
    }
    try {
  const { status, data: response_users } = await apiGet(
    path,
    type === "search" ? filter : type
  );

  if (status === 200 && response_users.success) {
    const results = response_users.results;

    setData(results.data);
    setSumData(results.sumData);

    setAccountError(results.data?.length === 0);

    setPageCount(results.totalPages);

    const commission = results.data?.reduce((a, v) => {
      return a + (parseInt(v?.stake?.commission) || 0);
    }, 0);

    const stake = results.data?.reduce((a, v) => {
      return a + (parseInt(v?.stake?.realAmount) || 0);
    }, 0);

    const sportsPL = results.data?.reduce((a, v) => {
      return a + (parseInt(v?.sportData?.amount) || 0);
    }, 0);

    const casinoPL = results.data?.reduce((a, v) => {
      return a + (parseInt(v?.casinoData?.amount) || 0);
    }, 0);

    setObj({
      commission: commission.toFixed(2),
      stake: stake.toFixed(2),
      totalSportsPL: sportsPL.toFixed(2),
      totalCasinoPL: casinoPL.toFixed(2),
    });
  }
} catch (err) {
  console.error("Fetch error:", err);

  const message =
    err?.response?.data?.message ||
    err?.message ||
    "Something went wrong while fetching data.";

  toast.error(message);
}
  };

  useEffect(() => {
    //  getData();
    setViewPage(filter.page ? filter.page - 1 : 0);
  }, [filter]);

  const search = async (item) => {
    let obj = {
      page: filter.page,
      page_size: filter.page_size,
      fromPeriod: filter.fromPeriod,
      toPeriod: filter.toPeriod,
      filterByDay: filter.filterByDay,
      created_by: item._id,
      userType: item?.userType,
    };
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }
    let path;
    if (check == "AprofitDownline") {
      path = apiPath.reportDownline;
    } else {
      path = apiPath.reportMarket;
    }
    try {
      const { status, data: response_users } = await apiGet(path, obj);
      if (status === 200) {
        if (response_users.success) {
          setData(response_users.results.data);
          setPageCount(response_users.results.totalPages);
          setSumData(response_users.results.sumData);
          // console.log(response_users.results.data, "data");
          const commission = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.sportData?.commission);
            return a;
          }, 0);
          const stake = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.stake?.realAmount);
            return a;
          }, 0);
          const sportsPL = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.sportData?.amount);
            return a;
          }, 0);

          const casinoPL = response_users?.results?.data?.reduce((a, v) => {
            a = parseInt(a) + parseInt(v?.casinoData?.amount);
            return a;
          }, 0);
          if (check == "AprofitDownline") {
            setObj({
              commission: commission.toFixed(2) || 0,
              stake: stake.toFixed(2) || 0,
              totalSportsPL: sportsPL.toFixed(2) || 0,
              totalCasinoPL: casinoPL.toFixed(2) || 0,
            });
          } else {
            setObj({
              commission: commission.toFixed(2) || 0,
              stake: stake.toFixed(2) || 0,
              totalSportsPL: sportsPL.toFixed(2) || 0,
              totalCasinoPL: casinoPL.toFixed(2) || 0,
            });
          }
        }
      }
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  return (
    <div className="top-header-inner">
      <section className="main-inner-outer py-4">
        <Container fluid>
          <Row>
            <div className="db-sec">
              <h2 className="common-heading">
                Profit/Loss Report by{" "}
                {check == "AprofitMarket" ? "Market" : "Downline"}
              </h2>
            </div>{" "}
            <Col md={12}>
              <div className="inner-wrapper">
                <Form className="bet_status">
                  <Row>
                    <Col xl={12} md={12}>
                      <Row>
                        <Col lg={2} sm={3} className="mb-lg-0 mb-3">
                          <div className="bet-sec">
                            <Form.Label className="mb-0 w-100">
                              Time Zone
                            </Form.Label>
                            <Form.Select
                              className="small_select"
                              style={{ minWidth: "80px" }}
                              onChange={(e) =>
                                setFilter({
                                  ...filter,
                                  timeZone: e.target.value,
                                })
                              }
                              value={filter.timeZone}
                              aria-label="Default select example"
                            >
                              {/* <option value={""}>All</option> */}
                              <option value={""}>
                                IST(Bangalore / Bombay / New Delhi) (GMT+5:30)
                              </option>
                              {/* <option value={2}>Tennis</option>
                              <option value={1}>Soccer</option> */}
                            </Form.Select>
                          </div>
                        </Col>
                        <Col
                          lg={2}
                          sm={6}
                          className="mb-lg-0 mb-3 flex-grow-0"
                          style={{ minWidth: `260px` }}
                        >
                          <div className="bet-sec bet-period">
                            <Form.Label className="mb-0">Period</Form.Label>
                            <Form.Group className="form-group">
                              {/* <Form.Control
                                className="small_form_control"
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    fromPeriod: e.target.value,
                                    filterByDay: "",
                                  })
                                }
                                max={new Date().toISOString().split("T")[0]}
                                value={filter.fromPeriod}
                                type="date"
                              /> */}
                              <DatePicker
                                className="small_form_control"
                                selected={
                                  filter.fromPeriod
                                    ? new Date(filter.fromPeriod)
                                    : null
                                }
                                onChange={(date) =>
                                  setFilter({
                                    ...filter,
                                    fromPeriod: date
                                      .toISOString()
                                      .split("T")[0],
                                    filterByDay: "",
                                  })
                                }
                                dateFormat="yyyy-MM-dd"
                                maxDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                placeholderText="Select a date"
                                onFocus={(e) => e.target.blur()}
                              />
                              <Form.Control
                                style={{ marginLeft: "4px", width: "47px" }}
                                className="small_form_control"
                                type="text"
                                placeholder="09:00"
                                disabled
                              />
                            </Form.Group>
                          </div>
                        </Col>
                        <Col
                          style={{ padding: "0" }}
                          lg={2}
                          sm={6}
                          className="mb-lg-0 mb-3 flex-grow-0"
                        >
                          <div className="bet-sec bet-period">
                            <Form.Label
                              style={{ marginRight: "2px" }}
                              className="mb-0"
                            >
                              to
                            </Form.Label>
                            <Form.Group className="form-group">
                              {/* <Form.Control
                                className="small_form_control"
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    toPeriod: e.target.value,
                                    filterByDay: "",
                                  })
                                }
                                min={
                                  filter?.fromPeriod
                                    ? new Date(filter?.fromPeriod)
                                        .toISOString()
                                        .split("T")[0]
                                    : new Date()
                                }
                                max={new Date().toISOString().split("T")[0]}
                                value={filter.toPeriod}
                                type="date"
                              /> */}

                              <DatePicker
                                className="small_form_control"
                                selected={
                                  filter.toPeriod
                                    ? new Date(filter.toPeriod)
                                    : null
                                }
                                onChange={(date) =>
                                  setFilter({
                                    ...filter,
                                    toPeriod: date.toISOString().split("T")[0],
                                    filterByDay: "",
                                  })
                                }
                                dateFormat="yyyy-MM-dd"
                                minDate={
                                  filter?.fromPeriod
                                    ? new Date(filter?.fromPeriod)
                                        .toISOString()
                                        .split("T")[0]
                                    : new Date()
                                }
                                maxDate={new Date().toISOString().split("T")[0]}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                placeholderText="Select a date"
                                onFocus={(e) => e.target.blur()}
                              />
                              <Form.Control
                                style={{ marginLeft: "4px", width: "47px" }}
                                className="small_form_control"
                                type="text"
                                placeholder="08:59"
                                disabled
                              />
                            </Form.Group>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <div className="history-btn mt-2">
                    <ul className="list-unstyled mb-0">
                      <li>
                        <Button
                          className={
                            filter.filterByDay === "today"
                              ? "me-0 theme_light_btn"
                              : "me-0 theme_light_btn"
                          }
                          onClick={(e) =>
                            setFilter({
                              ...filter,
                              filterByDay: "today",
                            })
                          }
                          style={{ padding: `0 10px`, lineHeight: `25px` }}
                        >
                          Just For Today
                        </Button>
                      </li>
                      <li>
                        <Button
                          className={
                            filter.filterByDay === "yesterday"
                              ? "me-0 theme_light_btn"
                              : "me-0 theme_light_btn"
                          }
                          onClick={(e) =>
                            setFilter({
                              ...filter,
                              filterByDay: "yesterday",
                            })
                          }
                          style={{ padding: `0 10px`, lineHeight: `25px` }}
                        >
                          From Yesterday
                        </Button>
                      </li>
                      <li>
                        <Button
                          className="theme_dark_btn"
                          onClick={() => getData("search")}
                        >
                          Get P & L
                        </Button>
                      </li>
                    </ul>
                  </div>
                </Form>
              </div>
            </Col>
            {/* {data && data?.length > 0 && <HierarchyNew parmas={parmas} />} */}
            {data && data?.length > 0 && (
              <Col md={12} sm={12} lg={12} className="mt-4">
                <section className="account-table aprofit-downline">
                  <div className="responsive transaction-history report-t">
                    <Table>
                      <thead>
                        <tr>
                          {check !== "AprofitMarket" && (
                            <th
                              scope="col"
                              className="text-center"
                              style={{ width: "2%" }}
                            >
                              Serial No
                            </th>
                          )}
                          <th scope="col">UID</th>
                          {check == "AprofitMarket" && (
                            <>
                              <th scope="col">Sports</th>
                              <th scope="col">Client Name</th>
                              <th scope="col">Report Type</th>
                              <th scope="col">Event Name</th>
                              <th scope="col">Report Name</th>
                              <th scope="col">Comm.</th>
                              <th scope="col">Upline/Total P/L</th>
                            </>
                          )}

                          {check !== "AprofitMarket" && (
                            <>
                              {/* <th scope="col">Stake</th>
                            <th scope="col">Downline P/L</th>
                            <th scope="col">Player P/L</th>
                            <th scope="col">Comm.</th>
                            <th scope="col">Upline/Total P/L</th> */}
                              {/* <th scope="col" className="text-end">
                              Sports PL{" "}
                            </th>
                            <th scope="col" className="text-end">
                              Casino P/L{" "}
                            </th> */}
                              <th scope="col" className="text-end">
                                Stake
                              </th>
                              <th scope="col" className="text-end">
                                Player P/L
                              </th>{" "}
                              {parmas?.user_type !== "agent" && (
                                <th scope="col" className="text-end">
                                  Downline P/L
                                </th>
                              )}
                              {parmas?.user_type !== "agent" && (
                                <>
                                  <th scope="col" className="text-end">
                                    SS PT
                                  </th>{" "}
                                  <th scope="col" className="text-end">
                                    SS Comm.
                                  </th>
                                  <th scope="col" className="text-end">
                                    SS Rebate
                                  </th>
                                  <th scope="col" className="text-end">
                                    SS Total
                                  </th>
                                </>
                              )}
                              {parmas?.user_type == "agent" && (
                                <th scope="col" className="text-end">
                                  Master Comm.
                                </th>
                              )}
                              <th scope="col" className="text-end">
                                Upline P/L
                              </th>
                            </>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {/* const resultTotalStake = item?.bets_list?.reduce((a, v) => {
                    a = parseInt(a) + parseInt(v.amount);
                    return a;
                  }, 0); */}
                        <>
                          {data && data?.length > 0 ? (
                            data?.map((item, index) => {
                              return  item?.stake?.amount == 0 || item.amount==0 ? (
                                ""
                              ) : (
                                <>
                                  <tr key={index + 1}>
                                    {/* <td>
                                  <Link
                                    to={`/AprofitDownline/${item.id}/${item.id}`}
                                  >
                                    <i className="fas fa-plus-square pe-2"></i>{" "}
                                    <span className="d-inline-block">SD</span>
                                    {item.firstName} {item.lastName}
                                  </Link>
                                </td> */}
                                    {check == "AprofitMarket" && (
                                      <>
                                        <td>{item._id}</td>
                                        <td>
                                          {constant.betCheckObj[item.eventType]}
                                        </td>
                                        <td>{item.clientName}</td>
                                        <td>{item.reportType}</td>
                                        <td>{item.matchName}</td>
                                        <td>{item.reportName}</td>
                                        <td>0.00</td>
                                        <td>
                                          {item.transactionType == "credit" ? (
                                            <span className="">
                                              {`( +${helpers.currencyFormat(
                                                item.amount.toFixed(2)
                                              )} )`}
                                            </span>
                                          ) : (
                                            <span className="text-danger">
                                              {`( -${helpers.currencyFormat(
                                                item.amount.toFixed(2)
                                              )} )`}
                                            </span>
                                          )}
                                        </td>
                                      </>
                                    )}
                                    {check !== "AprofitMarket" && (
                                      <>
                                        <td
                                          className="text-center"
                                          width={`2%`}
                                        >
                                          {index + 1}
                                        </td>

                                        <td width={`20%`}>
                                          {parmas?.user_type !== "agent" && (
                                            <>
                                              {id == item?._id ? (
                                                <img
                                                  onClick={(e) => {
                                                    setId("");
                                                    // search(item);
                                                    showDetail(
                                                      e,
                                                      item?._id,
                                                      item?.userType
                                                    );
                                                  }}
                                                  style={{
                                                    height: "15px",
                                                    marginRight: "5px",
                                                  }}
                                                  src={require("../assets/images/expand-open.png")}
                                                />
                                              ) : (
                                                <img
                                                  onClick={(e) => {
                                                    setId(item?._id);
                                                    // search(item);
                                                    showDetail(
                                                      e,
                                                      item?._id,
                                                      item?.userType
                                                    );
                                                  }}
                                                  style={{
                                                    height: "15px",
                                                    marginRight: "5px",
                                                  }}
                                                  src={require("../assets/images/expand-close.png")}
                                                />
                                              )}{" "}
                                            </>
                                          )}
                                          {item?.userType == "user" ? (
                                            <>
                                              <Link
                                                to={`/betting-profit-loss/${item?._id}/${item?.userType}`}
                                                // className="text-primary"
                                                style={{
                                                  textDecoration: "underline",
                                                  color: "#2789ce",
                                                  fontSize: "11px",
                                                }}
                                                target="_blank"
                                              >
                                                <span
                                                  className={
                                                    constant?.user_status[
                                                      item?.userType || ""
                                                    ]
                                                  }
                                                >
                                                  {
                                                    constant?.user_status[
                                                      item?.userType || ""
                                                    ]
                                                  }
                                                </span>{" "}
                                                {item?.username || null}
                                              </Link>
                                            </>
                                          ) : (
                                            <>
                                              <Link
                                                to={`/AprofitDownline/${item._id}/${item?.userType}`}
                                                onClick={() => search(item)}
                                                style={{
                                                  textDecoration: "underline",
                                                  color: "#2789ce",
                                                  fontSize: "11px",
                                                }}
                                              >
                                                <span
                                                  className={
                                                    constant?.user_status[
                                                      item?.userType || ""
                                                    ]
                                                  }
                                                >
                                                  {
                                                    constant?.user_status[
                                                      item?.userType || ""
                                                    ]
                                                  }
                                                </span>
                                                {item?.username || null}
                                              </Link>
                                            </>
                                          )}
                                        </td>
                                        {/* <td className="text-end">
                                        {" "}
                                        {Math.sign(item?.sportData?.amount) !==
                                        -1 ? (
                                          <span className="text-danger">
                                            (
                                            {helpers.currencyFormat(
                                              "-" + item?.sportData?.amount
                                            )}
                                            )
                                          </span>
                                        ) : (
                                          helpers.currencyFormat(
                                            Math.abs(item?.sportData?.amount)
                                          )
                                        )}
                                      </td>
                                      <td className="text-end">
                                        {" "}
                                        {Math.sign(item?.casinoData?.amount) !==
                                        -1 ? (
                                          <span className="text-danger">
                                            (
                                            {helpers.currencyFormat(
                                              "-" + item?.casinoData?.amount
                                            )}
                                            )
                                          </span>
                                        ) : (
                                          helpers.currencyFormat(
                                            Math.abs(item?.casinoData?.amount)
                                          )
                                        )}
                                      </td> */}
                                        <td className="text-end" width={`5%`}>
                                          {helpers.currencyFormat(
                                            Math.abs(
                                              item?.stake?.stakeAmount.toFixed(2) || 0.0
                                            )
                                          )}
                                        </td>
                                        {/* <td className="text-end">
                                        {helpers.currencyFormat(
                                          item?.sportData?.commission
                                        )}
                                      </td> */}
                                        <td className="text-end" width={`10%`}>
                                          {" "}
                                          {Math.sign(item?.stake?.amount) !==
                                          -1 ? (
                                            helpers.currencyFormat(
                                              item?.stake?.amount.toFixed(2) || 0.0
                                            )
                                          ) : (
                                            <span className="text-danger">
                                              (
                                              {helpers.currencyFormat(
                                                Math.abs(
                                                  item?.stake?.amount.toFixed(2) || 0.0
                                                )
                                              )}
                                              )
                                            </span>
                                          )}
                                        </td>
                                        {parmas?.user_type !== "agent" && (
                                          <td
                                            className="text-end"
                                            width={`10%`}
                                          >
                                            {" "}
                                            {Math.sign(item?.stake?.amount) !==
                                            -1 ? (
                                              helpers.currencyFormat(
                                                item?.stake?.amount.toFixed(2)
                                              )
                                            ) : (
                                              <span className="text-danger">
                                                (
                                                {helpers.currencyFormat(
                                                  Math.abs(item?.stake?.amount.toFixed(2))
                                                )}
                                                )
                                              </span>
                                            )}
                                          </td>
                                        )}
                                        {parmas?.user_type !== "agent" && (
                                          <>
                                            <td
                                              className="text-end"
                                              width={`10%`}
                                            >
                                              0.00
                                            </td>{" "}
                                            <td
                                              className="text-end"
                                              width={`10%`}
                                            >
                                              0.00
                                            </td>{" "}
                                            <td
                                              className="text-end"
                                              width={`10%`}
                                            >
                                              0.00
                                            </td>{" "}
                                            <td
                                              className="text-end"
                                              width={`10%`}
                                            >
                                              0.00
                                            </td>
                                          </>
                                        )}
                                        {parmas?.user_type == "agent" && (
                                          <>
                                            <td
                                              className="text-end"
                                              width={`10%`}
                                            >
                                              {helpers.currencyFormat(
                                                item?.stake?.commission.toFixed(2)
                                              )}
                                            </td>{" "}
                                          </>
                                        )}
                                        <td className="text-end" width={`10%`}>
                                          {" "}
                                          {Math.sign(item?.stake?.amount) !==
                                          -1 ? (
                                            <span className="text-danger">
                                              ({" "}
                                              {helpers.currencyFormat(
                                                item?.stake?.amount.toFixed(2)
                                              )}
                                              )
                                            </span>
                                          ) : (
                                            <span
                                              style={{ paddingRight: "5px" }}
                                            >
                                              {helpers.currencyFormat(
                                                Math.abs(item?.stake?.amount).toFixed(2)
                                              )}
                                            </span>
                                          )}
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                  <tr
                                    className=""
                                    id={item?._id}
                                    style={{ display: getProperty }}
                                    key={item?._id}
                                  ></tr>
                                </>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={12}>
                                <span>
                                  You have no bets in this time period.
                                </span>
                              </td>
                            </tr>
                          )}
                          {data && data?.length > 0 && (
                            <>
                              {check == "AprofitMarket" && (
                                <tr>
                                  <th scope="col">Total</th>
                                  <th scope="col"></th>
                                  <th scope="col"></th>
                                  <th scope="col"></th>
                                  <th scope="col"></th>
                                  <th scope="col"></th>
                                  <th scope="col"></th>
                                  <th scope="col">
                                    {Math.sign(obj.downlinePnlAmount) === -1 ? (
                                      <span className="text-danger">
                                        {helpers.currencyFormat(
                                          Math.abs(obj.downlinePnlAmount).toFixed(2)
                                        )}
                                      </span>
                                    ) : (
                                      <span className="">
                                        (
                                        {helpers.currencyFormat(
                                          obj.downlinePnlAmount.toFixed(2)
                                        )}
                                        )
                                      </span>
                                    )}
                                  </th>
                                </tr>
                              )}
                              {check !== "AprofitMarket" && (
                                <tr className="total-bottom">
                                  {" "}
                                  <th scope="col"></th>
                                  <th scope="col">Total</th>
                                  <th scope="col" className="text-end">
                                    {helpers.currencyFormat(
                                      Math.abs(sumData?.stakeAmount).toFixed(2)
                                    )}
                                  </th>
                                  <th scope="col" className="text-end">
                                    {Math.sign(sumData?.PlayerPL) !== -1 ? (
                                      helpers.currencyFormat(
                                        Math.abs(sumData?.PlayerPL).toFixed(2)
                                      )
                                    ) : (
                                      <span className="text-danger">
                                        (
                                        {helpers.currencyFormat(
                                          Math.abs(sumData?.PlayerPL).toFixed(2)
                                        )}
                                        )
                                      </span>
                                    )}
                                  </th>{" "}
                                  {parmas?.user_type !== "agent" && (
                                    <th scope="col" className="text-end">
                                      {Math.sign(sumData?.PlayerPL) !== -1 ? (
                                        helpers.currencyFormat(
                                          Math.abs(sumData?.PlayerPL).toFixed(2)
                                        )
                                      ) : (
                                        <span className="text-danger">
                                          (
                                          {helpers.currencyFormat(
                                            Math.abs(sumData?.PlayerPL).toFixed(2)
                                          )}
                                          )
                                        </span>
                                      )}
                                    </th>
                                  )}
                                  {parmas?.user_type !== "agent" && (
                                    <>
                                      <th scope="col" className="text-end">
                                        0.00
                                      </th>{" "}
                                      <th scope="col" className="text-end">
                                        0.00
                                      </th>{" "}
                                      <th scope="col" className="text-end">
                                        0.00
                                      </th>{" "}
                                      <th scope="col" className="text-end">
                                        0.00
                                      </th>
                                    </>
                                  )}
                                  {parmas?.user_type == "agent" && (
                                    <>
                                      <th className="text-end">0.00</th>{" "}
                                    </>
                                  )}
                                  <th scope="col" className="text-end">
                                    {Math.sign(sumData?.PlayerPL) !== -1 ? (
                                      <span
                                        style={{ paddingRight: "5px" }}
                                        className="text-danger"
                                      >
                                        ({" "}
                                        {helpers.currencyFormat(
                                          Math.abs(sumData?.PlayerPL).toFixed(2)
                                        )}
                                        )
                                      </span>
                                    ) : (
                                      <span style={{ paddingRight: "10px" }}>
                                        {helpers.currencyFormat(
                                          Math.abs(sumData?.PlayerPL).toFixed(2)
                                        )}
                                      </span>
                                    )}
                                  </th>
                                </tr>
                              )}
                            </>
                          )}
                        </>
                      </tbody>
                    </Table>
                    {/* <div className="bottom-pagination">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next"
                      forcePage={viewpage}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={10}
                      pageCount={pageCount}
                      previousLabel="Prev"
                      renderOnZeroPageCount={null}
                      activeClassName="p-0"
                      activeLinkClassName="pagintion-li"
                    />
                  </div> */}

                    {data?.length > 0 && (
                      <Pagination
                        handlePageClick={handlePageClick}
                        pageCount={pageCount}
                        viewpage={viewpage}
                      />
                    )}
                  </div>
                </section>
              </Col>
            )}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default AprofitDownline;
